var _rect, _rect2, _rect3, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinistryOfChemicals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#f8f9fa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 200,
    height: 150,
    rx: 10,
    fill: "#1a3a5c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 200,
    height: 18,
    rx: 10,
    fill: "#f4d03f",
    opacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 118,
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#f4d03f",
    letterSpacing: 1
  }, "MoC")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 210,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    textAnchor: "middle",
    fill: "#2c3e50"
  }, "Ministry of Chemicals")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 228,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    fill: "#7f8c8d"
  }, "Govt. of India")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistryOfChemicals);
export default __webpack_public_path__ + "static/media/Ministry_of_Chemicals.b4731e018d302592aac4ca249cbce47e.svg";
export { ForwardRef as ReactComponent };